import { render, staticRenderFns } from "./BodyApplicationReview.vue?vue&type=template&id=7b1bc0b6&"
import script from "./BodyApplicationReview.vue?vue&type=script&lang=ts&"
export * from "./BodyApplicationReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports